import { render, staticRenderFns } from "./AttentionUser.vue?vue&type=template&id=041f2b8e&scoped=true&"
import script from "./AttentionUser.vue?vue&type=script&lang=js&"
export * from "./AttentionUser.vue?vue&type=script&lang=js&"
import style0 from "./AttentionUser.vue?vue&type=style&index=0&id=041f2b8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041f2b8e",
  null
  
)

export default component.exports